// @flow

import React, { type Node } from 'react';
import { useUniqueId, useMustShow } from '@tectonics/hooks';
import { useUserInputAsTextField } from '@tectonics/prs/user-input-values';
import { Label, TextField } from '../../../../../../commons/atoms';
import { InputGroup } from '../../../../../../commons/molecules';
import { InputMask } from '@tectonics/components/input-mask';
import { LATAM_PHONE_MASK } from '@tectonics/commons/masks.js';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { useUserInputValidationError, type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';
import { useSubmitting } from '@tectonics/prs/submitting';
import { ErrorLabel, InputHolder } from '../../commons';

export function InputChileanPhoneNumber(): Node {
  const inputId = useUniqueId();
  const submitting = useSubmitting();
  const mustShow = useMustShow('chileanPhoneNumber');

  const validationError = useUserInputValidationError('chileanPhoneNumber');
  const formHasBeenSent = useFormHasBeenSent();

  const [value, handleChange] = useUserInputAsTextField('chileanPhoneNumber');

  if (!mustShow){
    return null;
  }

  return (
    <InputHolder data-test-name="customer-phone-number">
      <InputGroup
        label={<Label htmlFor={inputId}>Telefono</Label>}
        input={
          <TextField
            as={InputMask}
            mask={LATAM_PHONE_MASK}
            id={inputId}
            type="tel"
            value={value}
            onChange={handleChange}
            fashion={formHasBeenSent && validationError ? 'error' : null}
            readOnly={submitting}
            data-error={formHasBeenSent && validationError ? 'error' : null}
            name="customer-phone-number"
          />
        }
      />
      {formHasBeenSent && validationError && (
        <ValidationErrorMessage validationError={validationError} />
      )}
    </InputHolder>
  );
}

type ValidationErrorMessageProps = {|
  validationError: UserInputValidationError,
|};

function ValidationErrorMessage({ validationError }: ValidationErrorMessageProps): Node {
  switch (validationError.id) {
    case 'empty':
      return <ErrorLabel>¡Ojo! Es obligatorio informar un número de teléfono.</ErrorLabel>;
    case 'invalid-pattern':
      return <ErrorLabel>El número de teléfono que informaste no es válido.</ErrorLabel>;
    case 'server-error':
      return <ErrorLabel>{serverErrorMessage(validationError.payload)}</ErrorLabel>;
    default:
      return <ErrorLabel>No es válido</ErrorLabel>;
  }
}
